<template>
  <div ref="dragTableContainer" class="ls-drag-table-container" :style="{height: `${height}px`}">
    <a-table :columns="columns" :dataSource="cacheNewDataSource" :pagination="false" bordered :scroll="{ x: true, y:height - 64 }">
      <template slot="customTitle">
        <div class="drag-table-left-header" ref="dragTableHeader">
          <div class="drag-table-left-header-date">日期</div>
          <div class="drag-table-left-header-load">负荷</div>
          <div class="drag-table-left-header-total">汇总</div>
          <div class="drag-table-left-header-line">产线</div>
        </div>
      </template>
      <template v-for="(date, dateIndex) in tableObj.dateList" :slot="date">
        <div class="date-header-container" :key="date" :style="{ width: `${dateColumnWidthArr[dateIndex]}px`}">
          <div class="date-header-text">
            {{ date }}
          </div>
          <div class="date-header-line"></div>
          <div class="date-header-text">
            {{ getLoadNumByDate(date) }}
          </div>
          <div class="date-header-line"></div>
          <div class="date-header-text">
            {{ getTotalNum(date) }}
          </div>
        </div>
      </template>
      <div slot="tags" slot-scope="record, index, column, row" class="tag-area">
        <div class="tag-container">
          <!-- 拖拽组件，设置只有class带有drag-only-this的才允许进行拖动 -->
          <Draggable
            :value="index[row.dataIndex]"
            @end="(e)=>handleTagItemDrag(e, column, row)"
            :group="{ name: 'table', pull: true, put: true }"
            :options="{
              scroll: true,
              animation: 300,
              handle: '.drag-only-this'
            }"
            class="tag-drag-area"
            :move="(e) => handleMove(e, column, index, row, record)"
          >
            <transition-group type="transition" name="flip-list" class="transition-group-area" :id="`${column}&${row.dataIndex}`" :key="`${column}&${row.dataIndex}`">
              <ProductionSchedulingItem :class="{'drag-only-this': !tag.wipEntityName || !tag.wipEntityName.trim()}" :is-line-lose-efficacy="checkLineIsLoseEfficacy(index)" :error-order-no="errorOrderNo" :ref="`item${tag.id}`" :item-data="tag" class="name-item" @handle-item-click="handleItemClick(tag, column, row)" v-for="tag in record" :key="tag.id" />
            </transition-group>
          </Draggable>
        </div>
      </div>
    </a-table>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Draggable from "vuedraggable";
import deepClone from "lodash.clonedeep";
import "ant-design-vue/dist/antd.css";
import ProductionSchedulingItem from "./components/ProductionSchedulingItem.vue";

export default defineComponent({
  name: "LsDragTable",
  components: {
    Draggable,
    ProductionSchedulingItem
  },
  props: {
    height: {
      type: String | Number
    },
    tableObj: {
      type: Object,
      require: () => {}
    },
    vendorName: {
      type: String,
      default: ''
    },
    errorOrderNo: {
      type: String,
      default: ''
    },
    lineStatusData: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    // tableObj: {
    //   handler: function (val) {
    //     if (val && val.dateList && val.dateList[0]) {
    //       this.initTableObj()
    //     }
    //   },
    //   deep: true
    // }
  },
  mounted () {
    this.$nextTick(() => {
      this.resizeTableArea()
    })
  },
  data () {
    return {
      columns: [
        {
          fixed: 'left',
          dataIndex: "vendorName",
          key: "vendorName",
          width: 80,
          colSpan: 3,
          slots: { title: 'customTitle' },
          align: 'center',
          customRender: (text, row, index) => {
            const obj = {
              children: text,
              attrs: {}
            };
            if (index === 0) {
              obj.attrs.rowSpan = this.tableObj.tableData.length;
            }
            // These two are merged into above cell
            if (index !== 0) {
              obj.attrs.rowSpan = 0;
            }
            return obj;
            }
        },
        {
          fixed: 'left',
          width: 80,
          colSpan: 0,
          dataIndex: 'lineName',
          align: 'center'
        },
        {
          dataIndex: '',
          key: '',
          minWidth: 100,
          scopedSlots: { customRender: 'tags' }
        }
      ],
      dateTotalObj: {},
      dataSource: [], // 显示在页面上的数据数组
      cacheNewDataSource: [], // 用以存放用户拖动后真实的数据数组
      dateColumnWidthArr: []
    };
  },
  methods: {
    handleMove (e, column, index, row, record) {
      let afterDragItemHaveWipEntityName = false // 拖动的工单后面是否有已有工单号的工单
      let afterDragItemHaveWipEntityNameCount = 0 // 拖动的工单后面有工单号的工单数量
      const isSameLineAndDayMove = e.from === e.to // 是否在同一行内移动
      let dragedAfterDragItemHaveWipEntityName = false // 拖动之后的工单后面是否有已有工单号的工单
      let dragedAfterDragItemHaveWipEntityNameCount = 0 // 拖动之后的工单后面有工单号的工单数量

      // 判断拖动的工单后面是否有已有工单号的工单（拖动前）
      const moveItemData = e.dragged.__vue__.itemData
      let tempIndex = null
      record.forEach((item, itemIndex) => {
        if (item.id === moveItemData.id) {
          tempIndex = itemIndex
        }
        if (tempIndex !== null && itemIndex > tempIndex && item.wipEntityName && item.wipEntityName.trim() !== '') {
          afterDragItemHaveWipEntityName = true
          afterDragItemHaveWipEntityNameCount++
        }
      })

      // 判断拖动后的工单所在位置后面是否有已有工单号的工单（拖动后）
      const dragToId = e.to.id.split('&')[0]
      const dragToDate = e.to.id.split('&')[1]
      const dragToIndex = e.draggedContext.futureIndex
      this.cacheNewDataSource[dragToId][dragToDate].forEach((item, itemIndex) => {
        if (itemIndex >= dragToIndex && item.wipEntityName && item.wipEntityName.trim() !== '') {
          dragedAfterDragItemHaveWipEntityName = true
          dragedAfterDragItemHaveWipEntityNameCount++
        }
      })

      if (isSameLineAndDayMove && afterDragItemHaveWipEntityNameCount !== dragedAfterDragItemHaveWipEntityNameCount) {
        // 当同行移动的情况下，移前与移后有工单号的工单数量应该保持一致，否则不能拖拽
        return false
      }

      if (afterDragItemHaveWipEntityName && !isSameLineAndDayMove) {
        // 如果工单当前位置后面已有有工单号的工单，并且不是同一行内移动，则不允许拖动
        console.log('拖动的工单后面已有工单号的工单，并且不是同一行内移动，不允许拖动')
        return false
      }
      if (dragedAfterDragItemHaveWipEntityName && !isSameLineAndDayMove) {
        // 如果工单拖动后所在位置后面已有有工单号的工单，并且不是同一行内移动，则不允许拖动
        console.log('拖动后的工单所在位置后面已有工单号的工单，并且不是同一行内移动，不允许拖动')
        return false
      }

      return true
    },
    initTableObj () {
      this.columns = []
      this.dataSource = []
      this.cacheNewDataSource = []
      this.$nextTick(() => {
        this.columns = [
          {
            fixed: 'left',
            dataIndex: "vendorName",
            key: "vendorName",
            width: 80,
            colSpan: 3,
            align: 'center',
            slots: { title: 'customTitle' },
            customRender: (text, row, index) => {
              const obj = {
                children: text,
                attrs: {}
              };
              if (index === 0) {
                obj.attrs.rowSpan = this.tableObj.tableData.length;
              }
              // These two are merged into above cell
              if (index !== 0) {
                obj.attrs.rowSpan = 0;
              }
              return obj;
              }
          },
          {
            fixed: 'left',
            width: 80,
            colSpan: 0,
            align: 'center',
            dataIndex: 'workshopCode'
          },
          {
            fixed: 'left',
            width: 80,
            colSpan: 0,
            align: 'center',
            dataIndex: 'lineName'
          }
        ]
        console.log(this.tableObj.tableData)
        this.tableObj.dateList.forEach(item => {
          this.columns.push({
            slots: { title: item },
            dataIndex: item,
            key: item,
            minWidth: 100,
            scopedSlots: { customRender: 'tags' }
          })
        })
        if (this.tableObj.tableData.length > 0) {
          this.tableObj.tableData[0].vendorName = this.vendorName
        }
        this.cacheNewDataSource = deepClone(this.tableObj.tableData)
        this.dataSource = this.cacheNewDataSource
        this.$emit('update-cache-data-source', this.cacheNewDataSource)
        this.$nextTick(() => {
          this.resizeTableArea()
          setTimeout(() => {
            this.initColumnsWidth()
          }, 100);
        })
      })
    },
    refreshTableData (val) {
      this.dataSource = val
    },
    // 调整列，要对应调整每列的宽度
    initColumnsWidth () {
      console.log('渲染宽度')
      const tableRowEl = this.$refs.dragTableContainer.getElementsByClassName('ant-table-row')[0]
      Array.from(tableRowEl.children).forEach((cellItem, cellIndex) => {
        // 设置宽度，从第4列开始算，前3列是固定列
        if (cellIndex > 2) {
          if (Number(cellItem.clientWidth) >= 100) {
            this.$set(this.dateColumnWidthArr, cellIndex - 3, cellItem.clientWidth)
          } else {
            this.$set(this.dateColumnWidthArr, cellIndex - 3, 100)
          }
        }
      })
    },
    resizeTableArea () {
      const domTableBody = this.$refs.dragTableContainer.getElementsByClassName('ant-table-body')[0]
      const domEmptyTableBody = this.$refs.dragTableContainer.getElementsByClassName('ant-table-placeholder')[0]
      const domTableHeader = this.$refs.dragTableContainer.getElementsByClassName('ant-table-thead')[0]
      const tableBodyHeight = domTableBody.clientHeight
      if (tableBodyHeight < (this.height - 64)) {
        if (this.dataSource.length > 0) {
          domTableBody.getElementsByTagName('table')[0].style.height = `${this.height - domTableHeader.clientHeight - 12}px`
        } else {
          domEmptyTableBody.style.height = `${this.height - domTableHeader.clientHeight}px`
        }
      }
    },
    handleItemClick (item) {
      console.log('drag-table', item)
      this.$emit('handle-drag-item-click', item)
    },
    // 当拖动可排序组件中的标签项时触发此方法。
    handleTagItemDrag (e, column, row) {
      // 从拖动事件中提取信息
      const dragItemVueNode = e.item.__vue__; // 获取拖动项的 Vue 实例
      const newIndex = e.newIndex; // 获取项被放置的索引
      const newDate = e.to.id.split('&')[1]; // 从目标 ID 中提取新日期
      const newLineIndex = e.to.id.split('&')[0]; // 从目标 ID 中提取新行索引

      const oldIndex = e.oldIndex; // 获取拖动的标签在旧位置的索引
      const oldDate = e.from.id.split('&')[1]; // 从源 ID 中提取旧日期
      const oldLineIndex = e.from.id.split('&')[0]; // 从源 ID 中提取旧行索引

      if (newDate === oldDate && newLineIndex === oldLineIndex) {
        // 同单元格内拖动，插入/移除会影响index，需要判断先后
        if (Number(newIndex) > Number(oldIndex)) {
          // 往后拖，不会影响oldIndex
          const oldTag = this.cacheNewDataSource[oldLineIndex][oldDate].find(tag => tag.id.toString() === dragItemVueNode.$vnode.key);
          this.cacheNewDataSource[oldLineIndex][oldDate].splice(oldIndex, 1);
          this.cacheNewDataSource[newLineIndex][newDate].splice(newIndex, 0, oldTag);
        } else {
          // 往前拖
          const oldTag = this.cacheNewDataSource[oldLineIndex][oldDate].find(tag => tag.id.toString() === dragItemVueNode.$vnode.key);
          this.cacheNewDataSource[newLineIndex][newDate].splice(newIndex, 0, oldTag);
          this.cacheNewDataSource[oldLineIndex][oldDate].splice(oldIndex + 1, 1); // 此时oldIndex需要加1
        }
      } else {
        // 不同单元格内拖动，插入/移除不会影响index，先后顺序无所谓
        // 从旧位置获取正在拖动的标签
        const oldTag = this.cacheNewDataSource[oldLineIndex][oldDate].find(tag => tag.id.toString() === dragItemVueNode.$vnode.key);
        // 将拖动的标签插入新位置
        this.cacheNewDataSource[newLineIndex][newDate].splice(newIndex, 0, oldTag);
        // 从旧位置移除拖动的标签
        this.cacheNewDataSource[oldLineIndex][oldDate].splice(oldIndex, 1);
      }

      // 输出更新后的缓存数据源并发出事件以通知父组件
      this.$emit('update-cache-data-source', this.cacheNewDataSource);
      this.$nextTick(() => {
        setTimeout(() => {
          // 重新初始化列宽
          this.initColumnsWidth();
        }, 200);
      })
    },
    getLoadNumByDate (date) {
      const tempLoadItem = this.tableObj.loadList.find(item => item.startDate === date)
      if (tempLoadItem) {
        return `${parseFloat((tempLoadItem.avgLoad * 100).toFixed(4))}%`
      } else {
        return '0%'
      }
    },
    getTotalNum (date) {
      let tempTotal = 0
      this.cacheNewDataSource.forEach(item => {
        item[date].forEach(dateItem => {
          tempTotal += dateItem.orderQuantity
        })
      })
      return tempTotal
    },
    checkLineIsLoseEfficacy (lineData) {
      const lineName = lineData.lineName
      const lineStatusItem = this.lineStatusData.find(item => item.prodLineCode === lineName)
      return lineStatusItem.prodLineStatus === 'N'
    }
  }
});
</script>

<style scoped lang="less">
.ls-drag-table-container{
  width: 100%;
  user-select: none;
  /deep/.ant-table-thead > tr:first-child > th:first-child {
    position: relative;
    min-height: 95px;
    background: #fff url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxsaW5lIHgxPSIwIiB5MT0iMCIgeDI9IjEwMCUiIHkyPSIxMDAlIiBzdHJva2U9IiNlOGU4ZTgiIHN0cm9rZS13aWR0aD0iMSIvPjwvc3ZnPg0K) no-repeat 100% center;
  }
  /deep/.ant-table-tbody > tr > td {
    padding: 0;
  }
  /deep/.ant-table-thead > tr > th {
    padding: 0;
  }
  /deep/.ant-table-thead > tr > th .ant-table-header-column {
    width: 100%;
  }
}
.list-group {
  padding: 0;
  margin: 0;
  list-style: none;
}

.list-group-item {
  cursor: move;
}

.name-item {
  cursor: pointer;
}

.name-item:active {
  cursor: move;
}

.tag-area {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 5px;
}

.tag-area-disabled {
  background-color: #ff4d4f;
}

.tag-container {
  display: flex;
  min-height: 30px;
  .tag-drag-area {
    height: 30px;
    width: 100%;
    min-width: 100px;
  }
}

.date-header-container {
  text-align: center;
  .date-header-text {
    margin: 5px 0;
  }
  .date-header-line {
    width: 100%;
    height: 1px;
    background-color: #e8e8e8;
    transform: scaleY(0.5);
  }
}

.drag-table-left-header {
  min-height: 95px;
  width: 100%;
  padding: 6px;
  .drag-table-left-header-date {
    position: absolute;
    right: 6px;
    top: 16%;
    transform: translateY(-50%);
  }
  .drag-table-left-header-load {
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
  }
  .drag-table-left-header-total {
    position: absolute;
    right: 6px;
    top: 83%;
    transform: translateY(-50%);
  }
  .drag-table-left-header-line {
    position: absolute;
    bottom: 6px;
    left: 6px;
  }
}
.transition-group-area {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
